import { matchRoutes, type DataRouter } from 'react-router';

/*
 * A plain <a href="/listing/12"> — chat messages, map popups (Leaflet HTML),
 * a few older components — makes the browser load the whole site again: a
 * white flash, lost scroll and state, a «refresh for no reason». Same-origin
 * clicks on such links go through the router instead. Left alone: links the
 * router already handled, new-tab / modifier clicks, downloads, other sites,
 * files (/sitemap.xml matches only the catch-all route), `data-reload` links,
 * and the static prerendered copy shown before the app starts.
 */
export function installSpaLinks(router: DataRouter): void {
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
    if (!a || a.closest('#root-ssr')) return;
    if ((a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-reload')) return;
    const url = new URL(a.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    // An in-page anchor (#section) keeps the browser's own scrolling.
    if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) return;
    const matches = matchRoutes(router.routes, url.pathname);
    if (!matches || matches.some((m) => m.route.path === '*')) return;
    e.preventDefault();
    void router.navigate(url.pathname + url.search + url.hash);
  });
}
